import { createFileRoute, useRouter } from '@tanstack/react-router';
import { MembershipPlanForm } from '@/components/organisms/pricebook/MembershipPlanForm';
import type { MembershipPlan } from '@/components/organisms/pricebook/support/membership-plan-shared';

export const Route = createFileRoute('/_dashboard/dashboard/membership-plans/new')({
  component: NewMembershipPlanPage,
});

function NewMembershipPlanPage() {
  const router = useRouter();

  function handleSuccess(plan: MembershipPlan) {
    // @ts-expect-error — search required by TanStack Router v1.168
    void router.navigate({
      to: '/dashboard/membership-plans/$id',
      params: { id: plan.id ?? '' },
    });
  }

  function handleCancel() {
    // @ts-expect-error — search required by TanStack Router v1.168
    void router.navigate({ to: '/dashboard/membership-plans' });
  }

  return (
    <div className="h-full flex flex-col">
      <MembershipPlanForm onSuccess={handleSuccess} onCancel={handleCancel} />
    </div>
  );
}
